export const GET_SHARED_SNAP = 'GET_SHARED_SNAP';
export const GET_SHARED_SNAP_SUCCESS = 'GET_SHARED_SNAP_SUCCESS';
export const GET_SHARED_SNAP_FAILURE = 'GET_SHARED_SNAP_FAILURE';
export const ADD_COMMENT_TO_SHARED_SUCCESS = 'ADD_COMMENT_TO_SHARED_SUCCESS';
